import React from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import DateRangeFilter from '@/components/DateRangeFilter';
import { cn } from '@/utils/cn';

const TabWithFilter = ({ tabs, activeTab, onTabChange, onSearch, onReset, initialDateRange }) => {
  return (
    <Tabs.Root value={activeTab} onValueChange={onTabChange}>
      <Tabs.List className="flex gap-8 border-b border-gray-200">
        {tabs.map((tab) => (
          <Tabs.Trigger
            key={tab.value}
            value={tab.value}
            className={cn(
              'pb-4 relative text-gray-500 hover:text-gray-900 transition-colors',
              tab.special ? 'text-black font-medium' : 'data-[state=active]:text-black data-[state=active]:font-medium',
              'after:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5',
              'after:bg-black after:scale-x-0 data-[state=active]:after:scale-x-100 after:transition-transform'
            )}
          >
            {tab.label}
            {tab.count > 0 && (
              <span className="ml-1 text-sm text-gray-400">({tab.count})</span>
            )}
          </Tabs.Trigger>
        ))}
        <div className='mb-4 ml-auto'>
          <DateRangeFilter
            onSearch={onSearch}
            onReset={onReset}
            initialRange={initialDateRange}
          />
        </div>
      </Tabs.List>
    </Tabs.Root>
  );
};

export default TabWithFilter; 